<template>
    <div id="cduWrapper">
        <div id="cduHeader">
            <header-outer></header-outer>
            <header-outer ref="headerOuter"></header-outer>
        </div>
        <div id="cduBody">
            <body-outer @funckeyPress="funckeyPressed"></body-outer>
        </div>
    </div>
</template>

<script>
import HeaderOuter from 'views/cdu/cduHeader/Outer'
import BodyOuter from 'views/cdu/cduBody/Outer'
export default { 
    name: 'CduWrapper',
    data() {
        return {
            addKey: {
                letter: '+',
                isSub: false
            }
        }
    },
    components: {
        HeaderOuter,
        BodyOuter
    },
    methods: {
        funckeyPressed(e){
        try{
            switch (e){
                case "EXEC":
                    break
                case 'RTE':
                    this.$router.replace('/fmc/rte').catch(()=>{})
                    break
                case 'CLB':
                    this.$router.replace('/fmc/clb').catch(()=>{})
                    break
                case 'CRZ':
                    this.$router.replace('/fmc/crz').catch(()=>{})
                    break
                case 'DES':
                    this.$router.replace('/fmc/des').catch(()=>{})
                    break
                case 'LEGS':
                    this.$router.replace('/fmc/legs').catch(()=>{})
                    break
                case 'DEP\nARR':
                    this.$router.replace('/fmc/deparr').catch(()=>{})
                    break
                case 'HOLD':
                    this.$router.replace('/fmc/hold').catch(()=>{})
                    break
                case 'PROG':
                    this.$router.replace('/fmc/prog').catch(()=>{})
                    break
                case 'N1\nLIMIT':
                    this.$router.replace('/fmc/n1limit').catch(()=>{})
                    break
                case 'FIX':
                    this.$router.replace('/fmc/fix').catch(()=>{})
                    break
                case "MENU":
                    this.$router.replace('/menu').catch(()=>{})
                    break
                case 'INIT\nREF':
                    this.$router.replace('/fmc/pos').catch(()=>{})
                    break
                case 'NEXT\nPAGE':
                    const index = this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.index
                    if (index[0]>=1 && index[0]<index[1]){
                        this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.index.splice(0,1,index[0]+1)
                        this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.chgPage()
                    }else if(index[0]==index[1]){
                        this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.index.splice(0,1,1)
                        this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.chgPage()
                    }
                    break
                case 'PREV\nPAGE':
                    const indx = this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.index
                    if (indx[0]>1 && indx[0]<=indx[1]){
                        this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.index.splice(0,1,indx[0]-1)
                        this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.chgPage()
                    }else if(indx[0]==1){
                        this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.index.splice(0,1,indx[1])
                        this.$refs.headerOuter.$refs.currentScreen.$refs.currentPage.chgPage()
                    }
                    break
            }
        }catch(err){()=>{}}

        },
    },

    created() {
        this.$router.replace('/menu').catch(()=>{})
    },

}
</script>

<style scoped>
    #cduWrapper{
        width: 9.6rem;
        height: 14.52rem;
        background-color: var(--color-frame-bgc);
        margin: 2rem auto 0;
        color: #fff;
        position: relative;
        border-radius: .2rem;
        text-align: center;
    }
</style>